import { CountryCodeEnum } from "gen/model/countryCodeEnum";
import { StateCodeEnum } from "gen/model/stateCodeEnum";
import { TFunction } from "i18next";

interface EntityWithJurisdiction {
  jurisdiction_state?: StateCodeEnum;
  jurisdiction_country?: CountryCodeEnum;
}

export const localizeAddressState = (
  t: TFunction<["enums"]>,
  state: StateCodeEnum | null | undefined,
) => (state ? t(`enums:StateCodeEnum.${state}`) : undefined);

export const localizeJurisdiction = (
  t: TFunction<["enums"]>,
  entity: EntityWithJurisdiction | undefined | null,
) =>
  [
    localizeAddressState(t, entity?.jurisdiction_state),
    entity?.jurisdiction_country,
  ]
    .filter(Boolean)
    .join(", ");
